import { ITimeSource, TimeListener, TimeSourceUnsubscribe } from '@fe/core';

export class DefaultTimeSource implements ITimeSource {
    get currentTime(): number {
        return Math.trunc(Date.now() / 1000);
    }

    get currentTimeMs(): number {
        return Date.now();
    }

    // Not used by flight layer anyway
    on(listener: TimeListener): TimeSourceUnsubscribe {
        return () => {};
    }
    off(listener: TimeListener): void {}
}

export const defaultTimeSource = new DefaultTimeSource();
